import React, { useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Layout from "pages/shared/Layout";

import { StoreContext } from "shared/context/store-context";
import { PERMISSION_TYPES } from "@routebot/constants";
import { AuthContext } from "shared/context/auth-context";

import InventoryFuelItem from "./InventoryFuelItem";

const InventoryFuels = () => {
  const auth = useContext(AuthContext);
  const { t } = useTranslation();
  const itemType = "fuel";
  const listName = "main_fuels";

  const { fuels, drivers, vehicles, DeleteFuel, UpdateFuel, InsertFuel } = useContext(StoreContext);
  const [pageItems, setPageItems] = useState();

  useEffect(() => {
    setPageItems(fuels);
  }, [fuels]);

  const listColumns = [
    {
      field: "vehicle",
      headerName: t("inventoryFuel.columns.vehicle"),
      width: 200,
      valueGetter: (params) => vehicles.find((vehicle) => vehicle.id === params?.row?.vehicle)?.plate || "",
    },
    {
      field: "driver",
      headerName: t("inventoryFuel.columns.driver"),
      width: 300,
      valueGetter: (params) => drivers.find((driver) => driver.id === params?.row?.driver)?.name || "",
    },
    {
      field: "date",
      headerName: t("inventoryFuel.columns.date"),
      width: 150,
    },
    {
      field: "amount",
      headerName: t("inventoryFuel.columns.amount"),
      width: 150,
    },
    { field: "note", headerName: t("inventoryFuel.columns.note"), width: 300 },
  ];

  // const standardHelpItems = [
  //   "1. Şu anda erişim yetkinizin olduğu Yakıt Yönetimi ekranını görüntülemektesiniz.",
  //   "2. Filtreleri kullanarak ilgili yakıt alımı bilgilerine daha kolay erişim sağlayabilirsiniz.",
  //   "3. Sütun isimlerine tıklayarak sıralamayı değiştirebilirsiniz.",
  //   "4. Yeni yakıt alımı bilgisi eklemek için 'Yeni Yakıt Bilgisi Yarat' butonuna tıklayın.",
  // ];

  // const highlightedHelpItems = [
  //   "1. Bu sayfa sistemde tanımlı bir sürücünün bilgilerinin yönetilmesi için tasarlanmıştır. Sürücünün daha önce sistemde tanımlı olması gerekmektedir.",
  //   "2. Bir sürücünün sistemde tanımlanması için yukarıdaki SÜRÜCÜLER sekmesini kullanınız. Böylece sürücü SERVİSTESİN sistemine dahil edilmiş olacaktır.",
  //   "3. Ardından tekrar bu sekmeye gelerek SERVİSTESİN sistemine dahil edilen sürücünün bilgilerini 'Yeni Sürücü Bilgileri' yarat tuşuna basarak girebilirsiniz.",
  //   "4 Kimlik numarası girmediğiniz sürücünün dosya işlemlerini gerçekleştiremezsiniz.",
  //   "5. Kimlik bilgisi olduğu halde 'Dosyalara Git' tuşunu göremiyorsanız, alttaki Güncelle tuşuna bir kez basınız.",
  //   "6. Sürücünün kullandığı aracı bu ekranda değiştiremezsiniz. Araç değişikliği için yandaki ARAÇLAR sekmesini kullanınız.",
  // ];

  return (
    <Layout
      itemType={itemType}
      items={pageItems}
      listName={listName}
      listColumns={listColumns}
      showSelectedYear={false}
      isAlwaysFullScreen={false}
      hideCreateNewItem={!auth.permissions[PERMISSION_TYPES.ACCESS_TO_WRITE_INVENTORY]}
      SelectedItemComponent={InventoryFuelItem}
      NewItemComponent={InventoryFuelItem}
      DeleteItem={DeleteFuel}
      InsertItem={InsertFuel}
      UpdateItem={UpdateFuel}
      // standardHelpItems={standardHelpItems}
      // highlightedHelpItems={highlightedHelpItems}
    />
  );
};

export default InventoryFuels;
